interface LibraryData {
  id?: number;
  ownerOrganizationId?: number;
  name?: string;
  createDate?: string;
  createrId?: number;
  updateDate?: string;
  updaterId?: number;
  deleteDate?: string;
  deleterId?: number;
}

export class Library {
  public static getNonTranslatableFields(): string[] { return ['id', 'ownerOrganizationId', 'createDate', 'createrId', 'updateDate', 'updaterId', 'deleteDate', 'deleterId']; }
  public static getTranslatableFields(): string[] { return ['name']; }
  public static getFields(): string[] { return ['id', 'ownerOrganizationId', 'name', 'createDate', 'createrId', 'updateDate', 'updaterId', 'deleteDate', 'deleterId']; }
  public static getKeyFields(): string[] { return ['id', 'name']; }

  id?: number;
  ownerOrganizationId?: number;
  name?: string;
  createDate?: string;
  createrId?: number;
  updateDate?: string;
  updaterId?: number;
  deleteDate?: string;
  deleterId?: number;

  public static fromAPI(data: LibraryData, translationsData: any[]): Library {
    let translationData:any = {};
    for (let i = 0; i < translationsData.length; i++) {
      if (translationsData[i]['libraryId'] === data['id']) {
        translationData = translationsData[i];
        i = translationsData.length;
      }
    }
    return new Library({
      id: data.id,
      ownerOrganizationId: data.ownerOrganizationId,
      name: translationData.name ?? data.name,
      createDate: data.createDate,
      createrId: data.createrId,
      updateDate: data.updateDate,
      updaterId: data.updaterId,
      deleteDate: data.deleteDate,
      deleterId: data.deleterId
    });
  }


  public static fromAPIList(data: LibraryData[], translations: any[]): Library[] {
    return data.map((item: LibraryData) => Library.fromAPI(item, translations));
  }


  constructor({id, ownerOrganizationId, name, createDate, createrId, updateDate, updaterId, deleteDate, deleterId}: LibraryData) {
    this.id = id;
    this.ownerOrganizationId = ownerOrganizationId;
    this.name = name;
    this.createDate = createDate;
    this.createrId = createrId;
    this.updateDate = updateDate;
    this.updaterId = updaterId;
    this.deleteDate = deleteDate;
    this.deleterId = deleterId;
  }

  public toJson(): LibraryData {
    return {
      id: this.id,
      ownerOrganizationId: this.ownerOrganizationId,
      name: this.name,
      createDate: this.createDate,
      createrId: this.createrId,
      updateDate: this.updateDate,
      updaterId: this.updaterId,
      deleteDate: this.deleteDate,
      deleterId: this.deleterId
    };
  }
}
